import * as React from 'react';
import { FormConfig, FormSecrets } from '@components/common/formSchema/types';
import FormSchema, { Group } from '@components/common/formSchema';
import { ISourceDefinition } from '@stores/sourceDefinitionsList';
import { SourceConfig } from '@stores/source/types';

interface IWebhookConfigureProps {
  sourceDefinition: ISourceDefinition;
  onSettingsChange: (value: FormConfig, isValid: boolean) => void;
  initialSettings?: SourceConfig;
  secretConfig?: FormSecrets;
  disabled?: boolean;
}

export const WebhookConfigure = ({
  sourceDefinition,
  onSettingsChange,
  initialSettings,
  disabled,
  secretConfig,
}: IWebhookConfigureProps) => {
  const schema = sourceDefinition.uiConfig as Group[];
  return (
    <div style={{ minWidth: 500 }} className="p-t-lg p-b-lg" data-testid="webhook-configure-test">
      <FormSchema
        schema={schema || []}
        onChange={onSettingsChange}
        initialSettings={initialSettings as FormConfig}
        disabled={!!disabled}
        secretConfig={secretConfig}
      />
    </div>
  );
};
